/* eslint-disable eqeqeq */
import { Container, Divider, Grid, ThemeProvider, Typography, useMediaQuery } from "@mui/material";
import { Box } from "@mui/system";
import { useTranslation } from "react-i18next";
import Check from "../../../assets/logo/check.svg";
import { formatCryptoDecimals, formatNumber, isFiatTransaction, trimText } from "../../../utils";
import { succesTheme } from "../theme";
import AppStatus from "../../../components/AppStatus";
import AppButton from "../../../components/AppButton";
import { HomeOutlined } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import AppToolTip from "../../../components/AppTooltip";
import FeedbackSurvey from "./FeedbackSurvey";

export default function SuccessComponent({ withdrawData }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("md"));
  const showFees = (data) => {
    if(data?.feeCharged?.hasOwnProperty('feeEnabled')) {
      return data?.feeCharged?.feeEnabled;
    }
    return true;
  }
  return (
    <ThemeProvider theme={succesTheme}>
      <Container sx={{ height: isSmallScreen ? 'auto' : '90vh', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
        <Grid container sx={{ color: "#F8FAFF" }}>
          <Grid item xs={12}>
            <Box
              sx={{
                display: "flex",
                flexFlow: "column",
                justifyContent: "space-between",
                alignItems: "center",
                marginTop: 5,
                marginBottom: 5,
              }}
            >
              <Check style={{ width: 94, height: 94 }} />
              <Typography
                color={"#F8FAFF"}
                textAlign="center"
                marginTop={3}
                fontWeight={700}
                fontSize={24}
              >
                {t("TransferInitiateSuccessfully")}
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={4}>
            <Typography fontSize={14} fontWeight={400}>
              {t("status")}:
            </Typography>
          </Grid>
          <Grid item xs={8} textAlign="right">
            <AppStatus status={parseFloat(withdrawData.status.toString())} />
          </Grid>
          <Grid item xs={4}>
            {t("Amount Requested")}:
          </Grid>
          <Grid item xs={8} textAlign="right">
            {withdrawData.amount} {withdrawData.currency}
          </Grid>
          {isFiatTransaction(withdrawData.service) && <>
            <Grid item xs={4}>
              Payment Method
            </Grid>
            <Grid item xs={8} textAlign="right">
              {withdrawData?.feeCharged?.paymentMethodDisplayName}
            </Grid>
          </>}
          <Grid item xs={5}>
            Currency Requested:
          </Grid>
          {!isFiatTransaction(withdrawData.service) && <Grid item xs={7} textAlign="right">
            {withdrawData?.cryptoCurrency?.id
              ? `${withdrawData?.cryptoCurrency?.id}`
              : ``}&nbsp;({
              withdrawData?.cryptoNetwork?.toUpperCase()
            })
          </Grid>}
          {isFiatTransaction(withdrawData.service) && <Grid item xs={7} textAlign="right">
            {withdrawData.feeCharged.currency}
          </Grid>}
          {showFees(withdrawData) && <Grid item xs={4}>
            {t("processing-fee")}:
          </Grid>}
          {(!isFiatTransaction(withdrawData.service) && showFees(withdrawData)) && <Grid item xs={8} textAlign="right">
            {withdrawData.feeCharged.processingFeeUsd} USD {(withdrawData.feeCharged.processingFeePercent != 0 && withdrawData?.feeCharged?.processingFeePercent) ? `+ ${withdrawData.feeCharged.processingFeePercent}%` : ""}
          </Grid>}
          {
            (isFiatTransaction(withdrawData.service) && showFees(withdrawData)) && <Grid item xs={8} textAlign="right">
              {withdrawData.feeCharged.processingFeeFlatUsd} USD {(withdrawData.feeCharged.processingFeePercent != 0) ? `+ ${withdrawData.feeCharged.processingFeePercent}%` : ""}
            </Grid>
          }
          {!!withdrawData?.feeCharged?.networkFeeCrypto && (
            <>
              <Grid item xs={4}>
              {t('Network fees')}:
              </Grid>
              <Grid item xs={8} textAlign="right">
                {formatCryptoDecimals(withdrawData.feeCharged.networkFeeUsd)}&nbsp;
                USD
              </Grid>
            </>
          )}
          <Grid item xs={4}>
          {t("Amount To Be Sent")}:
          </Grid>
          {!isFiatTransaction(withdrawData.service) && <Grid item xs={8} textAlign="right">
            {formatNumber(Number(withdrawData.feeCharged.payoutAmount) + Number(withdrawData.feeCharged.networkFeeUsd))}&nbsp;
            USD
          </Grid>}
          {isFiatTransaction(withdrawData.service) && <Grid item xs={8} textAlign="right">
            {formatNumber(Number(withdrawData.feeCharged.payoutAmountUsd))}&nbsp;
            USD
          </Grid>}

          <Grid item xs={4}>
            {t('exchangeRate')}:
          </Grid>
          {!isFiatTransaction(withdrawData.service) && <Grid item xs={8} textAlign="right">
            1 {withdrawData.cryptoCurrency.id} ={" "}
            {formatCryptoDecimals(
              withdrawData.feeCharged.cryptoCurrencyCurrentRate
            )}
            &nbsp;
            {withdrawData?.currency}
          </Grid>}
          {isFiatTransaction(withdrawData.service) && <Grid item xs={8} textAlign="right">
            <span>1 USD =  </span>
            <AppToolTip
              enterTouchDelay={0}
              title={`${withdrawData?.feeCharged?.rkflRate?.toString()} ${withdrawData?.feeCharged?.currency}`}
              placement="top" arrow>
              <span>{trimText(withdrawData?.feeCharged?.rkflRate?.toString(), 6)}</span>
            </AppToolTip>&nbsp;{withdrawData?.feeCharged?.currency}
          </Grid>}
        </Grid>
        <Divider />
        <Box
          sx={{
            display: "flex",
            flexFlow: "row",
            justifyContent: "space-between",
            marginTop: 2,
          }}
        >
          <Typography fontSize={16} color="#F8FAFF">
            {t("AmountReceived")}:
          </Typography>
          <Box>
            {!isFiatTransaction(withdrawData.service) && <Typography
              fontSize={16}
              fontWeight={400}
              color="#F8FAFF"
              textAlign={"right"}
            >
              {formatCryptoDecimals(withdrawData.feeCharged.payoutAmountCrypto)}{" "}
              {withdrawData?.cryptoCurrency?.id}
            </Typography>}
            {isFiatTransaction(withdrawData.service) && <Typography
              fontSize={16}
              fontWeight={400}
              color="#F8FAFF"
              textAlign={"right"}
            >
              {formatNumber(withdrawData.feeCharged.payoutAmount)}{" "}
              {withdrawData?.feeCharged?.currency}
            </Typography>}
          </Box>
        </Box>
        {!isFiatTransaction(withdrawData.service) && <Typography
          variant="subtitle1"
          color={"#D4D4D8"}
          textAlign={"center"}
          fontSize={12}
          marginTop={2}
          lineHeight={1.5}
        >
          {t("transfer.disclaimer3")}
        </Typography>}
        <FeedbackSurvey />
        <AppButton
          sx={{ marginTop: 2 }}
          startIcon={<HomeOutlined />}
          onClick={() => navigate("/home", {
            state: {
              showFeedbackForm: true
            },
          })}
          title={t("BackDashboard")}
        ></AppButton>
      </Container>
    </ThemeProvider>
  );
}
